import { useCallback } from 'react';
import type { Notification } from '@/entities/notification/model';
import { PAGES } from 'common/enums';
import useIsPageAvailable from 'hooks/use-is-page-available';

export const useFilterNotification = () => {
  const isIncomingInvoicesPageAvailable = useIsPageAvailable(PAGES.EINGANGSRECHNUNG);

  const filterNotification = useCallback(
    (data: Notification[]): Notification[] => {
      return data.filter(notification =>
        isIncomingInvoicesPageAvailable
          ? true
          : notification.attributes.regardingObjectFromText?.logicalName !== 'uds_eingangsrechnung'
      );
    },
    [isIncomingInvoicesPageAvailable]
  );

  return { filterNotification };
};
